import React, { useEffect, useState, useRef } from "react";
import "../Purchase/Purchase.css";
import { Navbar } from "../Common/Navbar/Navbar";
import { Footer } from "../Common/Footer/Footer";
import { Accordian } from "../Common/Accordian";
import BlackDollor from "../../Images/BundlDetail/blackdollor.svg";
import BlackTime from "../../Images/BundlDetail/blacktime.svg";
import { ConfigToken } from "../Auth/ConfigToken";
import axios from "axios";
import { base_url } from "../Auth/BackendAPIUrl";
// import { ToastContainer, toast } from "react-toastify";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Popup } from "../Common/Popup/Popup";
import { amountDecimal } from "../Utils/amountDecimal";
import { convertBundlEnglishToRoute } from "./bundlRouteUtils";

let newToastId = null;
export const CustomBundl = ({ user, lang, setLang }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const query = searchParams.get("search");
  const [brandError, setBrandError] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 440);
  const [firstOrder, setFirstOrder] = useState(false);
  const location = useLocation();
  const { state } = location;
  const [addonPayLoads, setAddonPayLoads] = useState({});
  const [brandInput, setBrandInput] = useState("");
  const [isSameBundl, setIsSameBundl] = useState(false);
  const [showDetails, setDetails] = useState(false);
  const [isFromLogin, setIsFromLogin] = useState(state?.fromLogin);
  const [openPopup, setOpenPopup] = useState(false);
  const isClearingCart = useRef(false);
  const isSubmitting = useRef(false);

  const [addOnLang, setAddOnLang] = useState([
    { id: 1, language: "English", label: "English", isChecked: true },
    { id: 2, language: "Arabic", label: "Arabic", isChecked: false },
    { id: 3, language: "both", label: "Both (+2,000 SAR)", isChecked: false },
  ]);

  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
    });
    // getprojects()
    if (state && "project_name" in state) {
      setBrandInput(state.project_name);
    }
    const handleResize = () => {
      setIsMobile(window.innerWidth < 440);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (isFromLogin) {
      setBrandError(false);
      setBrandError(state?.project_name && false);
      // createPayload();
    }
  });

  useEffect(() => {
    if (user?.is_active) {
      getprojects();
    }
  }, [user]);

  const emptyCart = async () => {
    setOpenPopup(false);

    // Set flag to prevent createPayload from updating localStorage
    isClearingCart.current = true;

    // Clear localStorage payloads
    localStorage.removeItem("payloads");

    // Reset states
    setBrandInput("");
    setAddonPayLoads({});
    setIsSameBundl(false);

    // Delete cart from API
    try {
      await axios.delete(`${base_url}/api/order/cart/`, ConfigToken());
    } catch (error) {
      console.error("Error deleting cart:", error);
      // Still proceed even if API call fails
    }

    // Reset flag after a short delay to allow state updates to complete
    setTimeout(() => {
      isClearingCart.current = false;
    }, 100);

    createPayload();
  };

  const toastErrorMessage = (msg) => {
    const message = msg;

    if (newToastId) {
      toast.dismiss(newToastId);
    }

    newToastId = toast(message, {
      duration: 3000,
      style: {
        color: "#1BA56F",
        border: `1px solid #1BA56F`,
        fontWeight: "700",
        background: "#fff",
        boxShadow: "none",
        borderRadius: "0px",
      },
    });
  };

  const createPayload = async () => {
    if (isSubmitting.current) return;
    isSubmitting.current = true;
    try {
    if (brandInput == "") {
      // toast.error(
      //   lang === "ar" ? "الحد اختر اسمًا لمشروعك" : `Name your brand`,
      //   {
      //     position: toast?.POSITION?.TOP_RIGHT,
      //     toastId: "required-value-toast",
      //     icon: false,
      //     style: {
      //       color: "#D83D99",
      //       fontWeight: "700",
      //     },
      //   }
      // );
      // toastErrorMessage(
      //   lang === "ar" ? "الحد اختر اسمًا لمشروعك" : `Name your brand`
      // );
      const element = document.getElementById("brandInput");
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      setBrandError(true);
      return false;
    }
    if (firstOrder && addonPayLoads.total_price < 800) {
      // toast.error(
      //   lang === "ar"
      //     ? "الأدنى للطلب يجب أن يكون 800"
      //     : `Minimum order amount should be 800`,
      //   {
      //     position: toast?.POSITION?.TOP_RIGHT,
      //     toastId: "required-value-toast",
      //     icon: false,
      //     style: {
      //       color: "#D83D99",
      //       fontWeight: "700",
      //     },
      //   }
      // );
      toastErrorMessage(
        lang === "ar"
          ? "الأدنى للطلب يجب أن يكون 800"
          : `Minimum order amount should be 800`
      );
      const element = document.getElementById("brandInput");
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return false;
    }
    if (addonPayLoads.item_list.length == 0) {
      // toast.error(
      //   lang === ""
      //     ? "التسوق يرجى إضافة عنصر إلى سلة"
      //     : `Please add an Item to Checkout`,
      //   {
      //     position: toast?.POSITION?.TOP_RIGHT,
      //     toastId: "required-value-toast",
      //     icon: false,
      //     style: {
      //       color: "#D83D99",
      //       fontWeight: "700",
      //     },
      //   }
      // );
      toastErrorMessage(
        lang === "ar"
          ? "التسوق يرجى إضافة عنصر إلى سلة"
          : `Please add an Item to Checkout`
      );
      return false;
    }
    const savedPayload = JSON.parse(localStorage.getItem("payloads") || "{}");
    const payload = isFromLogin
      ? savedPayload
      : {
          order_name: brandInput,
          // bundle_id: location.state.bundlDetail?.id,
          total_time: addonPayLoads.total_time,
          // total_price: addonPayLoads.total_price,
          total_price: overAllAmount(addonPayLoads.item_list),
          tax_treatment: addonPayLoads.tax_treatment,
          tax: addonPayLoads.tax,
          item_list: addonPayLoads.item_list,
          addons: addonPayLoads,
          bundle_id: null,
          order_status: "in_cart",
        };

    try {
      // Don't update localStorage if we're clearing the cart
      if (!isClearingCart.current) {
        localStorage?.setItem("payloads", JSON.stringify(payload));
      }
      const response = await axios.post(
        `${base_url}/api/order/create/`,
        payload,
        ConfigToken()
      );
      if (response.status === 201) {
        // Check for redirect_message in response
        const responseData = response.data?.data?.data || response.data?.data || response.data;
        const redirectMessage = responseData?.redirect_message;
        const bundlEnglish = responseData?.bundl_english;
        
        // Process redirect_message if present (backend returns it for orders < 800 for new clients)
        // Backend handles validation, so if redirect_message exists, it's valid
        if (redirectMessage) {
          // Show toast message
          toast(redirectMessage, {
            duration: 4000,
            position: "bottom-right",
          });
          
          // Convert bundl_english to route name and redirect
          if (bundlEnglish) {
            const routeName = convertBundlEnglishToRoute(bundlEnglish);
            if (routeName) {
              navigate(`/bundldetail/${routeName}`, {
                state: { orderData: responseData },
              });
              return;
            }
          }
          // If bundl_english is missing or invalid, fall back to mycart
          console.warn("redirect_message present but bundl_english is missing or invalid, redirecting to mycart");
        }
        
        navigate("/mycart", { state: { orderData: responseData } });
      }
    } catch (error) {
      console.error("Error creating order:", error);
      // Don't update localStorage if we're clearing the cart
      if (!isClearingCart.current) {
        localStorage?.setItem("payloads", JSON.stringify(payload));
      }
      navigate(`/login?next_url=custombundl`, {
        state: {
          project_name: brandInput,
        },
      });
    }
    } finally {
      isSubmitting.current = false;
    }
  };

  const getprojects = async () => {
    try {
      const response = await axios.get(`${base_url}/api/order/`, ConfigToken());
      if (response.data) {
        const resProjects = response.data.data.filter(
          (item) => item.order_status != "in_cart"
        );
        if (resProjects.length) {
          setFirstOrder(false);
        } else {
          setFirstOrder(true);
        }
      }
    } catch (e) {
      console.log(e);
      navigate(`/login?next_url=custombundl`, {
        state: {
          project_name: brandInput,
        },
      });
    }
  };

  useEffect(() => {
    if (user?.is_active) {
      const getcartData = async () => {
        try {
          const response = await axios.get(
            `${base_url}/api/order/cart/`,
            ConfigToken()
          );
          if (
            response?.data?.order_status === "in_cart" &&
            response?.data?.bundle_id !== null &&
            response?.data?.bundle_name !== null &&
            !state?.isBackToCustom &&
            response?.data?.item_details?.bundle_id !== null &&
            response?.data?.item_details?.bundle_name !== null
          ) {
            setOpenPopup(true);
          }
          if (
            response?.data?.item_details?.bundle_items.length > 0 ||
            response?.data?.item_details?.addon_items.length > 0
          ) {
            setBrandInput(response?.data?.project_name);
            setIsSameBundl(true);
          } else {
            setIsSameBundl(false);
          }
        } catch (e) {
          console.log(e);
          navigate(`/login?next_url=custombundl`, {
            state: {
              project_name: brandInput,
            },
          });
        }
      };
      getcartData();
    }
  }, [user, lang]);

  const calculateAmount = (id, amount, payload) => {
    if (id === "1") {
      if (payload === "convertPayload") {
        return Number(amount) + 2000;
      } else {
        return amountDecimal(Number(amount) + 2000);
      }
    } else {
      const totalQty = Number(id) - 1;
      const cal = totalQty * ((Number(amount) + 2000) / 2); // 2000 / 2 = 1000
      if (payload === "convertPayload") {
        return cal + Number(amount) + 2000;
      } else {
        return amountDecimal(cal + Number(amount) + 2000);
      }
    }
  };

  const overAllAmount = (items = {}, adjustments = {}) => {
    const selectedLanguage = addOnLang.find((ele) => ele.isChecked)?.language;
    let total = 0;
    for (const key in items) {
      const item = items[key];
      const quantity = Number(item.qty) || 0;
      const basePrice = parseFloat(item.unit_price || 0);
      const increment = item.price_increment || 0;

      let currentTotal = 0;

      if (
        item.addon_name === "Logo & Identity" &&
        selectedLanguage === "both"
      ) {
        if (quantity === 1) {
          console.log(items[key]);
          currentTotal = basePrice + 2000;
          items[key].total_price = currentTotal;
        } else if (quantity > 1) {
          const additionalUnits = quantity - 1;
          const incrementedPricePerUnit =
            (((basePrice + 2000) * increment) / 100) * additionalUnits;
          currentTotal = basePrice + 2000 + incrementedPricePerUnit;
          items[key].total_price = currentTotal;
        }
      } else {
        currentTotal =
          quantity === 1
            ? basePrice
            : basePrice + ((basePrice * increment) / 100) * (quantity - 1);
      }
      items[key].total_price = currentTotal;
      total += currentTotal;
    }
    return total;
  };
  // const calculateTotalAmount = () => {
  //   console.log("addonPayLoads", addonPayLoads.item_list);
  //   overAllAmount(addonPayLoads.item_list);
  // };

  // useEffect(() => {
  //   calculateTotalAmount();
  // }, [addonPayLoads]);

  const handleAddOnChange = (id, language) => {
    setAddOnLang((prev) =>
      prev.map((ele) =>
        ele.id === id && ele.language === language
          ? { ...ele, isChecked: true }
          : { ...ele, isChecked: false }
      )
    );
  };

  return (
    <div>
      {/* <ToastContainer /> */}
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            color: "#1BA56F",
            fontWeight: "700",
            borderRadius: "0px !important",
            border: `1px solid #1BA56F`,
          },
        }}
      />
      <Navbar isLang={lang} setIsLang={setLang} />
      <div className="bundl-detail mt-3">
        <div style={{ borderBottom: "1.5px solid #000000", width: "100%" }}>
          <h2>
            {location?.state?.title ||
              (lang === "ar" ? "صمم البندل الخاص بك" : "Customize Bundl")}
          </h2>
          {/* <p className='bundl-desc-title'>Main outcomes: Brand Identity, Commerce Collateral, Social Media Starter Kit.</p> */}
          <p className="bundl-desc">
            {lang === "ar"
              ? "المحتويات الأساسية: الهوية البصرية، عناصر التجار، مجموعة السوشال ميديا"
              : "In this bundl, you have the freedom to mix and match from different add-ons that have been carefully curated to guarantee you find all the items needed for the success of your project."}
          </p>
          <p className="one-minor mt-3">
            {lang === "ar"
              ? "هذي الباقة تشمل تعديل مجاني واحد"
              : "* This Bundl includes one minor revision"}
          </p>
        </div>

        <div className="bundl-section" style={{ position: "relative" }}>
          <div className="brand-details">
            <p
              style={
                window.innerWidth <= 441
                  ? lang === "ar"
                    ? {
                        fontSize: "18px",
                        fontWeight: "700",
                        lineHeight: "1.2",
                        textAlign: "right",
                      }
                    : { fontSize: "18px", fontWeight: "700", lineHeight: "1.2" }
                  : {
                      textAlign: lang === "ar" ? "right" : "left",
                      fontSize: "24px",
                      fontWeight: "700",
                    }
              }
            >
              {lang === "ar"
                ? "ما هو اسم مشروعك؟"
                : "What is the name of your brand?"}
            </p>
            <input
              id="brandInput"
              className={`brand-input ${brandError && "!border-[#D83D99]"}`}
              value={brandInput}
              onChange={(e) => {
                setBrandInput(e.target.value);
                setBrandError(false);
              }}
            />
            {brandError && (
              <p className="text-[#D83D99]">
                {lang === "ar"
                  ? "يرجى إدخال اسم المشروع"
                  : "Please enter name of the brand"}
              </p>
            )}
            <div>
              <Accordian
                accordianTitle={
                  lang === "ar"
                    ? "صمم البندل الخاصة بك"
                    : "Customize your Bundl!"
                }
                textColor={"#1BA56F"}
                addOnPayload={setAddonPayLoads}
                extraQty={{}}
                searchParams={query}
                isLang={lang}
                bundlePackageId={"custombundl"}
                isSameBundl={isSameBundl}
                addOnLang={addOnLang}
                handleAddOnChange={handleAddOnChange}
                addonPayLoads={addonPayLoads.item_list}
                overAllAmount={overAllAmount}
              />
            </div>
          </div>

          <div
            style={{
              ...(isMobile ? { border: "1px solid" } : {}),
            }}
            className={`
              border-r border-r-[rgba(0,0,0,0.1)]
              bundl-summary
              lg:overflow-visible md:overflow-visible
            `}
          >
              <div style={{
                  position: "sticky",
                  top: "0px",
                  alignSelf: "flex-start",
                  zIndex: 10,
              }}>
                  <div style={isMobile ? {overflow: 'auto', maxHeight: '80vh'}: {}}>
                      <div className="bundl-name ">
                          <p
                              className={`sm:text-[24px] xs:mb-0 xs:justify-between sm:block font-[700] px-0 !mb-2 display: flex
 ${lang === "ar" ? "text-right" : "text-left"}`}
                          >
                    <span className="font-normal">
                      {lang === "ar" ? "ملخص الطلب​" : "Summary"}
                    </span>
                              {isMobile && (
                                  <button
                                      onClick={() => setDetails(!showDetails)}
                                      style={{ color: "#1BA56F" }}
                                      className="text-[14px] font-normal underline uppercase"
                                  >
                                      {lang === "ar"
                                          ? showDetails
                                              ? "إخفاء التفاصيل"
                                              : "عرض التفاصيل"
                                          : showDetails
                                              ? "Hide Details"
                                              : "Show Details"}
                                  </button>
                              )}
                          </p>
                      </div>
                      {!isMobile || (isMobile && showDetails) ? (
                          <>
                              <div className="bundl-name">
                                  {addonPayLoads?.length > 0 && (
                                      <p
                                          style={{
                                              fontSize: "24px",
                                              fontWeight: "700",
                                              padding: "2% 0%",
                                          }}
                                      >
                                          {lang === "ar" ? "" : "Add ons"}
                                      </p>
                                  )}
                              </div>
                              {/* {addonPayLoads?.item_list?.map((addon, idx) => (
              <div key={idx} className='one-brand-identity block xs:flex sm:block'>
                <p className='text-[#000] sm:text-[20px] text-[20px] xs:text-[16px] font-[700] w-[45%]' >{addon.qty} {addon.addon_name}</p>
                <div className='flex xs:w-[55%] sm:w-full w-full'>
                  <p className='sm:text-[20px] text-[20px] xs:text-[16px] font-[700] w-[55%]' >+ {addon.unit_time * addon.qty} {lang === 'ar' ? 'يوما' : 'Days'}</p>
                  <p className='sm:text-[20px] text-[20px] xs:text-[16px] font-[700] w-[45%]'>+ {addon.qty ==1 ? parseFloat(addon.unit_price): parseFloat(addon.unit_price) + ((parseFloat(addon.unit_price) / 100) * addon.price_increment * (addon.qty - 1)) } {lang === 'ar' ? 'ريال' : 'SAR'}</p>
                </div>
              </div>
            ))} */}
                              {addonPayLoads?.item_list &&
                                  Object.entries(
                                      addonPayLoads.item_list.reduce((acc, addon) => {
                                          acc[addon.category] = acc[addon.category] || [];
                                          acc[addon.category].push(addon);
                                          return acc;
                                      }, {})
                                  ).map(([category, addons]) => (
                                      <div key={category}>
                                          <p
                                              className={`text-black sm:text-[20px] text-[20px] xs:text-[16px] font-[700] !mb-1 w-full px-[2%] mt-[3%] ${
                                                  lang === "ar" ? "text-right" : "text-left"
                                              }`}
                                          >
                                              {category}
                                          </p>
                                          {addons.map((addon, idx) => (
                                              <div
                                                  key={idx}
                                                  className={`one-brand-identity 
                        ${
                                                      addons.length - 1 === idx &&
                                                      "border-b-[1px] border-black"
                                                  }
                     ${
                                                      window.innerWidth < 1400 &&
                                                      addon.addon_name === "Logo & Identity" &&
                                                      addOnLang.find((ele) => ele.isChecked).language ===
                                                      "both"
                                                          ? "md:mb-[8%]"
                                                          : "mb-0"
                                                  }
                        xs:flex sm:block block flex-wrap justify-around`}
                                              >
                                                  <div className={`flex xs:w-[100%] w-full items-center`}>
                                                      <p
                                                          className={`text-black sm:text-[18px] text-[18px] xs:text-[16px] font-[400] !mb-1 xs:w-[75%]  lg:w-full md:w-full sm:w-full mt-[3px] ${
                                                              lang === "ar" ? "text-right" : "text-left"
                                                          }`}
                                                      >
                                                          {addon.qty}{" "}
                                                          {lang === "ar"
                                                              ? addon.addon_arabic
                                                              : addon.addon_name}{" "}
                                                          {addon.addon_name === "Logo & Identity"
                                                              ? addOnLang.find((ele) => ele.isChecked)
                                                                  ?.language === "both"
                                                                  ? "(English & Arabic)"
                                                                  : `(${
                                                                      addOnLang.find((ele) => ele.isChecked)
                                                                          ?.language
                                                                  })`
                                                              : null}
                                                      </p>
                                                      <p
                                                          className={`sm:text-[18px] text-[18px] xs:text-[16px] font-[400] lg:w-[40%] md:w-[50%] xs:w-[25%] !mb-0  ${
                                                              lang === "ar" ? "text-left" : "text-right"
                                                          }`}
                                                      >
                                                          {/* + {amountDecimal(addon.total_price)}{" "} */}
                                                          {addOnLang.find((ele) => ele.isChecked)
                                                              ?.language === "both" &&
                                                          addon.addon_name === "Logo & Identity"
                                                              ? calculateAmount(
                                                                  addon.qty,
                                                                  addon.unit_price,
                                                                  ""
                                                              )
                                                              : amountDecimal(addon.total_price)}{" "}
                                                          {lang === "ar" ? "ريال" : "SAR"}
                                                      </p>
                                                  </div>
                                              </div>
                                          ))}
                                      </div>
                                  ))}
                          </>
                      ) : (
                          ""
                      )}
                      <div className="bundl-checkout sticky bottom-0 bg-white border-t border-t-black sm:mt-3">
                          <div
                              className="total !font-[700]"
                              style={{ display: "flex" }}
                          >
                              <p
                                  className="sm:mb-3 xs:mb-0 flex items-center !xs:text-[16px] !sm:text-[20px]"
                                  style={{ width: "60%" }}
                              >
                                  <img
                                      src={BlackDollor}
                                      alt="Total Price"
                                      className="inline-block !font-[700] sm:ml-1 xs:ml-2"
                                  />
                                  <span
                                      className={`${
                                          lang === "ar" ? "mr-3" : "sm:ml-3 xs:ml-5"
                                      } !font-[700]`}
                                  >
                        {lang === "ar" ? "السعر الإجمالي :" : "Total Price :"}
                      </span>
                              </p>
                              <p
                                  className={`!font-[700] ${
                                      lang === "ar" ? "text-start" : "text-end"
                                  } !xs:text-[16px] !sm:text-[20px] sm:mb-3 xs:mb-0`}
                                  style={{ width: "40%" }}
                              >
                                  {amountDecimal(overAllAmount(addonPayLoads?.item_list || {}) || 0)}
                                  {lang === "ar" ? "\u00A0\u00A0\u00A0ريال" : "\u00A0\u00A0SAR"}
                              </p>
                          </div>
                          <div className="total" style={{ display: "flex" }}>
                              <p
                                  className="!xs:text-[16px] flex items-center !sm:text-[20px]"
                                  style={{ width: "60%" }}
                              >
                                  <img
                                      src={BlackTime}
                                      alt="Total Duration"
                                      className={`inline-block ${
                                          lang === "ar" ? "mr-[-5px]" : ""
                                      }`}
                                  />
                                  <span
                                      className={`${
                                          lang === "ar"
                                              ? "mr-2 xs:mr-3.5"
                                              : "xs:ml-4 sm:ml-1 ml-1"
                                      }`}
                                  >
                        {lang === "ar"
                            ? "المدة الإجمالية :"
                            : "Total Duration :"}
                      </span>
                              </p>
                              <p
                                  className={`!xs:text-[16px] ${
                                      lang === "ar" ? "text-start" : "text-end"
                                  } !sm:text-[20px]`}
                                  style={{ width: "40%" }}
                              >
                                  {addonPayLoads?.total_time ?? 0}
                                  {lang === "ar"
                                      ? "\u00A0\u00A0\u00A0\u00A0يوم"
                                      : "\u00A0\u00A0Days"}
                              </p>
                          </div>

                          <div className="flex justify-center items-center">
                              <div className="flex flex-col gap-[2%]">
                                  <button
                                      style={{ backgroundColor: "#1BA56F" }}
                                      className={`proceed uppercase !bg-[#1BA56F] mt-[3%]`}
                                      onClick={createPayload}
                                      type="button"
                                  >
                                      {lang === "ar" ? " إتمام الشراء" : "Proceed To Cart"}
                                  </button>

                                  <button
                                      style={{ backgroundColor: "#1BA56F" }}
                                      className={`proceed uppercase !bg-[#1BA56F] mt-[3%]`}
                                      onClick={() => {
                                          window.location.reload();
                                      }}
                                  >
                                      {lang === "ar" ? "إفراغ السلة" : "Empty Cart"}
                                  </button>
                              </div>
                          </div>
                          {/* {firstOrder && <p className='proceed-text'>{lang === 'ar' ? 'الحد الأدنى للطلب ٤٨٨٠ ريال سعوذي' : 'Your minimum total should be above 4880 SAR'}</p>} */}
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
      {window?.innerWidth >= 500 && <Footer isLang={lang} />}
      {openPopup && (
        <Popup
          openpopup={openPopup}
          setPopup={setOpenPopup}
          title={""}
          subTitle={
            lang === "ar"
              ? "لديك عناصر في سلة التسوق. هل ترغب في"
              : "You already have items in your cart. Would you like to."
          }
          onClick={emptyCart}
          save={lang === "ar" ? "الاستمرار" : "Continue"}
          cancel={lang === "ar" ? "الإلغاء" : "Cancel"}
          cancelClick={setIsFromLogin}
          isLang={lang}
        />
      )}
    </div>
  );
};
